import RefClient from 'ref-client-core';
import avoidSegmentContextMenu from './avoidSegmentContextMenu';

RefClient.mapPlugin.register(
  'avoidSegmentContextMenu',
  avoidSegmentContextMenu
);
